import { render, staticRenderFns } from "./commit-status-header.vue?vue&type=template&id=bafdce34&scoped=true&"
import script from "./commit-status-header.vue?vue&type=script&lang=ts&"
export * from "./commit-status-header.vue?vue&type=script&lang=ts&"
import style0 from "./commit-status-header.vue?vue&type=style&index=0&id=bafdce34&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafdce34",
  null
  
)

export default component.exports